import { useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";

const STATUS = ["new", "quoted", "in_progress", "completed", "declined"];

export default function AdminCustomOrders() {
  const [orders, setOrders] = useState([]);

  const load = () => api.get("/admin/custom-orders").then((r) => setOrders(r.data));
  useEffect(() => { load(); }, []);

  const update = async (id, status) => {
    try {
      await api.put(`/admin/custom-orders/${id}`, { status });
      toast.success("Updated");
      load();
    } catch (e) {
      toast.error(formatErr(e));
    }
  };

  return (
    <div data-testid="admin-custom-orders-page">
      <h1 className="font-display text-4xl text-[#F5F5DC] mb-10">Commission Requests</h1>
      <div className="space-y-4">
        {orders.map((o) => (
          <div key={o.id} className="bg-[#111] border border-[#2A2A2A] p-6" data-testid={`commission-${o.id}`}>
            <div className="flex justify-between items-start mb-3">
              <div>
                <p className="font-display text-xl text-[#F5F5DC]">{o.name}</p>
                <p className="text-[#A3A3A3] text-sm">{o.email} {o.phone && `· ${o.phone}`}</p>
                <p className="text-xs text-[#555] mt-1">{new Date(o.created_at).toLocaleString()}</p>
              </div>
              <select value={o.status} onChange={(e) => update(o.id, e.target.value)} className="input-dark w-auto text-xs" data-testid={`status-${o.id}`}>
                {STATUS.map((s) => <option key={s} value={s}>{s.replace("_", " ").toUpperCase()}</option>)}
              </select>
            </div>
            <div className="grid sm:grid-cols-2 gap-2 text-sm text-[#A3A3A3] mb-3">
              <p><span className="smallcaps">Type:</span> {o.project_type}</p>
              {o.dimensions && <p><span className="smallcaps">Dimensions:</span> {o.dimensions}</p>}
              {o.wood_preference && <p><span className="smallcaps">Preference:</span> {o.wood_preference}</p>}
              {o.budget && <p><span className="smallcaps">Budget:</span> {o.budget}</p>}
            </div>
            <p className="text-[#F5F5DC] text-sm whitespace-pre-wrap border-t border-[#2A2A2A] pt-3">{o.details}</p>
          </div>
        ))}
        {orders.length === 0 && <p className="text-[#A3A3A3]">No requests yet.</p>}
      </div>
    </div>
  );
}
